import React, { useEffect, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const RecaptchaGenerator = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [captchaToken, setCaptchaToken] = useState("");

  useEffect(() => {
    const generateToken = async () => {
      if (!executeRecaptcha) {
        console.error("Recaptcha not yet available");
        return;
      }
      try {
        // Execute reCAPTCHA and get the token
        const token = await executeRecaptcha("generate_token");
        setCaptchaToken(token);
      } catch (error) {
        console.error("Error generating reCAPTCHA token:", error);
      }
    };

    generateToken();
  }, [executeRecaptcha]);

  return (
    <div>
      {captchaToken ? (
        <p>
          reCAPTCHA Token: <strong>{captchaToken}</strong>
        </p>
      ) : (
        <p>Generating reCAPTCHA token...</p>
      )}
    </div>
  );
};

export default RecaptchaGenerator;
